import { useState } from "react";

import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import { LinkedInLoginModal } from "common/components/LinkedInLogin";
import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";

import LeadsImage from "assets/images/empty-placeholders/leads.png";

export default function ConnectAccount() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <EmptyPlaceholder
        imageSrc={LeadsImage}
        title="No leads yet"
        subtitle="Connect your LinkedIn account to import and sync leads automatically"
        actionComponent={
          <RestrictedComponent visibleFor={["accounts_full"]}>
            <Button onClick={() => setIsOpen(true)}>Connect account</Button>
          </RestrictedComponent>
        }
      />

      <LinkedInLoginModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
